<template>
  <div v-bind:class="{ 'col-12': isCheckout }">
      <form ref="form" method="post" class="mb-3 login-pwd-reset guest-login-form" >
          <div class="input-unit" data-validate="mail">
              <input type="email" name="email" autocomplete="email" :id="_uid" v-model="email" data-autofocus>
              <label v-if="!isCheckout" :for="_uid">{{ $translate("Ceres::Template.loginEmail") }}*</label>
              <label v-else for="_uid">Neue E-Mail Adresse</label>
          </div>
          <span class="error-msg">{{ $translate("Ceres::Template.loginEnterConfirmEmail") }}</span>

          <div class="text-right">
              <button v-if="!isCheckout" @click.prevent="validate" :disabled="isDisabled" class="btn btn-primary btn-medium btn-appearance">
                  <icon icon="arrow-right" :loading="isDisabled"></icon>
                  {{ $translate("Ceres::Template.loginNext") }}
              </button>
              <button v-else @click.prevent="validate" :disabled="isDisabled" class="btn btn-primary btn-medium btn-appearance">
                  <icon icon="arrow-right" :loading="isDisabled"></icon>
                  Ändern
              </button>
          </div>
      </form>
  </div>
</template>
<script>
import ValidationService from "../../../services/ValidationService";
import { navigateTo } from "../../../services/UrlService";
import { isDefined, isNullOrUndefined } from "../../../helper/utils";

const ApiService = require("../../../services/ApiService");

export default{

    props:
    {

        backlink:
        {
            type: String
        },
        isCheckout:
        {
            type: Boolean,
            default: false
        }
    },

    data()
    {
        return {
            email: "",
            isDisabled: false
        };
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            if (this.isCheckout)
            {
                $(".guest-login-form").hide();
            }
            // for old login view only (input in modal)
            if(!isNullOrUndefined(this.$parent.$refs.guestModal))
            {
              $(this.$parent.$refs.guestModal).on("hidden.bs.modal", () =>
              {
                  this.email = "";
                  ValidationService.unmarkAllFields(this.$refs.form);
              });
            }

        });
    },

    methods:
    {
        validate()
        {
            ValidationService.validate(this.$refs.form)
                .done(() =>
                {
                    this.authGuest();
                })
                .fail(invalidFields =>
                {
                    ValidationService.markInvalidFields(invalidFields, "error");
                });
        },

        authGuest()
        {
            this.isDisabled = true;

            ApiService.post("/rest/io/guest", { email: this.email })
                .done(() =>
                {
                    navigateTo(
                        isDefined(this.backlink) && this.backlink.length ? decodeURIComponent(this.backlink) : window.location.origin
                    );
                })
                .fail(() =>
                {
                    this.isDisabled = false;
                });
        }
    }
}
</script>
